import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { handleStateChangeFromProps } from '../../libs/helpers';
import TextareaInput from '../../libs/TextareaInput';

class InstitutionExtraInfo extends React.Component {
  state = {
    form: {},
    errors: {},
    onChange: null,
    completeProfile: false
  }
  /*
 -----------------------------------------------------------------------
 RENDER Functions
 -----------------------------------------------------------------------
 */
  static getDerivedStateFromProps(nextProps, prevState) {
    return handleStateChangeFromProps(nextProps, prevState)
  }
  render() {
    const { errors, form } = this.state;
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Extra Information
        </Typography>
        <Grid container spacing={3}>
          <TextareaInput
            width={12}
            value={form.comments}
            error={errors.comments}
            enabled={errors.enabled}
            onChange={this.props.onChange}
            name='comments'
            title='Any Comments?'
          />
        </Grid>
      </React.Fragment>
    );
  }
}

export default InstitutionExtraInfo;